import { styled, Tooltip, tooltipClasses } from "@mui/material";
import { Fragment } from "react";

export default function CustomHtmlTooltip({ToolTipContent, children}){
    const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        border: '1px solid #dadde9',
    },
    }));
    return(
        <HtmlTooltip
        arrow
        title = {
            <Fragment>
                {ToolTipContent}
            </Fragment>
        }
        >
            {children}
        </HtmlTooltip>
    );
}